module.exports = __webpack_public_path__ + "pmp.1afff0785a8b453be4c97a081c2f298f.gif";